/**
 * Complex reduce array.
 * @param {object} array object to count or sum property
 * @param {string} type count or sum, default count.
 * @param {string} field field to sum or count.
 * @param {object} groupBy field - property name to group, type - date or string, default string.
 * @param {object} filtersBy field - property name to filter, value - string to compare, type - include, exclude or greaterThan, default include.
 * @returns {object} object with property reduced.
 */
export function arrayReducer (array, type, field, groupBy, filtersBy) {
  return array.reduce((arrayReduced, row) => {
    let skipData = false
    const checkSkipData = (data, filter) => {
      if (filter && filter.field && filter.value) {
        if (filter.type === 'exclude') {
          if (data[filter.field] === filter.value) {
            return true
          }
        } else if (filter.type === 'greaterThan') {
          if (parseInt(data[filter.field], 0) < parseInt(filter.value, 0)) {
            return true
          }
        } else {
          if (data[filter.field] !== filter.value) {
            return true
          }
        }
      }
      return false
    }
    if (filtersBy && Array.isArray(filtersBy)) {
      for (let i = 0; i < filtersBy.length; i++) {
        skipData = checkSkipData(row, filtersBy[i])
        if (skipData) { break }
      }
    } else if (filtersBy && typeof filtersBy === 'object') {
      skipData = checkSkipData(row, filtersBy)
    }
    if (skipData) { return arrayReduced }
    if (groupBy && groupBy.field && groupBy.type) {
      var key
      if (groupBy.type === 'date') {
        key = new Date(row[groupBy.field]).toISOString().split('T')[0]
      } else if (groupBy.type === 'hour') {
        key = new Date(row[groupBy.field]).toISOString().split('T')[1].split(':')[0]
      } else {
        key = row[groupBy.field]
      }
      if (!arrayReduced.hasOwnProperty(key)) {
        arrayReduced[key] = 0
      }
      if (field && type === 'sum') {
        arrayReduced[key] += row[field]
      } else {
        arrayReduced[key]++
      }
    }
    return arrayReduced
  }, {})
}

export function sortArray (obj, isNumericSort, reverse) {
  isNumericSort = isNumericSort || false // by default text sort
  reverse = reverse || false // by default no reverse
  const reversed = (reverse) ? -1 : 1
  let sortable = obj
  if (isNumericSort) {
    sortable.sort(function (a, b) {
      return reversed * (a[1] - b[1])
    })
  } else {
    sortable.sort(function (a, b) {
      const x = a[1].toLowerCase()
      const y = b[1].toLowerCase()
      return x < y ? reversed * -1 : x > y ? reversed : 0
    })
  }
  return sortable
}



// WEBPACK FOOTER //
// ./src/utils/array.js